<ng-container [formGroup]="form">
  <!-- To: -->
  <div class="header subject">
    <div class="to">
      <span>To:</span>
    </div>
    <input tabindex="-1" type="text" class="form-control guest-name" [value]="inquiry.guestDetails?.name" disabled />
    <div class="cc">
      <a (click)="onToggleCC()" [class.active]="hasCC">CC</a>
      <a (click)="onToggleBCC()" [class.active]="hasBCC">BCC</a>
      <a (click)="onClose()" class="close-form">
        <i class="fal fa-times"></i>
      </a>
    </div>
  </div>

  <!-- CC -->
  <div
    *ngIf="hasCC"
    #ccRipple
    matRipple
    matTooltip="Please select an email from the list or type an email and hit enter key."
    matTooltipClass="text-center"
    matTooltipPosition="above"
    class="header subject cc-row"
  >
    <div class="to">
      <span>CC:</span>
    </div>
    <ng-select
      [items]="ccUsers"
      [addTag]="addNewCC"
      [hideSelected]="true"
      appendTo="body"
      multiple="true"
      bindLabel="name"
      placeholder="Nothing Selected"
      formControlName="cc"
      class="flex-fill"
    ></ng-select>
  </div>

  <!-- BCC -->
  <div *ngIf="hasBCC" #bccRipple matRipple class="header subject">
    <div class="to">
      <span>BCC:</span>
    </div>
    <app-select-search
      [items]="users$ | async"
      [ctrl]="form.get('bcc')"
      [inline]="true"
      [floatLabel]="'never'"
      bindLabel="name"
      bindValue="primaryEmail"
      placeholder="Nothing Selected"
      class="inline-select-search"
    ></app-select-search>
  </div>

  <!-- Inquiry -->
  <div *ngIf="guest" class="header subject">
    <div class="to">
      <span>Inquiry:</span>
    </div>
    <app-select-search
      [items]="inquiries$ | async"
      [ctrl]="inquiryCtrl"
      (search)="inquirySearch.next($event)"
      [multiple]="false"
      [inline]="true"
      [floatLabel]="'never'"
      bindLabel="name"
      bindValue="id"
      placeholder="Nothing Selected"
      class="inline-select-search"
    ></app-select-search>
  </div>

  <!-- Subject -->
  <div class="header subject">
    <div class="to">
      <span>Subject:</span>
    </div>
    <input tabindex="-1" type="text" class="form-control message-subject" formControlName="subject" />
  </div>

  <!-- editor -->
  <div class="comment-composer flex-fill">
    <ng-container *ngIf="showEditor">
      <div class="additional-action-icons d-inline-flex">
        <a
          (click)="onDataDictionary()"
          matTooltip="You may insert data tokens using data dictionary."
          matTooltipPosition="above"
          matTooltipClass="text-center"
          class="btn btn-link dictionary-btn"
        >
          <i class="fas fa-book"></i>
        </a>
        <a
          (click)="onAiResponder()"
          [matTooltip]="
            isAISubscriptionValid ? 'Generate a reply for the above message.' : 'Go to Appstore to subscribe for this'
          "
          matTooltipPosition="above"
          matTooltipClass="text-center"
          class="btn btn-link ai-btn"
        >
          <svg-icon
            [src]="
              isAISubscriptionValid ? 'assets/images/icons/ai-refresh-solid.svg' : 'assets/images/icons/ai-refresh.svg'
            "
            [svgStyle]="{ 'width.px': 25 }"
          ></svg-icon>
        </a>
        <a
          (click)="onPopup()"
          matTooltip="Expand the text editor"
          matTooltipPosition="above"
          matTooltipClass="text-center"
          class="btn btn-link dictionary-btn text-black"
          *ngIf="!isPopup"
        >
          <i class="fas fa-external-link"></i>
        </a>
      </div>
      <editor #tinyMceEditor [init]="editorOptions" [formControl]="form.get('messageHtml')" class="h-100"></editor>
    </ng-container>
    <div
      *ngIf="isAIGenerating"
      class="position-absolute d-flex flex-column align-items-center justify-content-center bg-white text-center"
      style="top: 0; left: 0; right: 0; bottom: 0; opacity: 0.95; z-index: 2"
    >
      <app-loading-section class="ai-generating"></app-loading-section>
      <div>
        Our AI is putting on its thinking cap, pondering your question. <br />
        Hang in there!
      </div>
    </div>
  </div>

  <!-- buttons -->
  <div class="comment-btns clearfix">
    <ul class="float-right">
      <li *ngIf="enableQuote | call: inquiry">
        <mat-checkbox
          matTooltip="Insert quote into email"
          matTooltipClass="text-center"
          matTooltipPosition="above"
          formControlName="addCost"
          class="mt-primary addcost"
        >
          Add Quote
        </mat-checkbox>
      </li>
      <li>
        <app-select-search
          [items]="templates$ | async"
          (change)="onTemplateChange($event)"
          [hasBlank]="true"
          [multiple]="false"
          [floatLabel]="'never'"
          bindLabel="name"
          placeholder="Select Template"
        ></app-select-search>
      </li>
      <li>
        <a
          (click)="onAttach()"
          matTooltip="Attach Files"
          matTooltipPosition="above"
          matTooltipClass="text-center"
          class="btn btn-link"
        >
          <i class="far fa-paperclip"></i>
        </a>
      </li>
      <li>
        <app-button
          (click)="onSend(form)"
          icon="fal fa-paper-plane"
          [class]="'success' | buttonClass"
          [disabled]="(isAddingMessage$ | async) || isAIGenerating"
          [loading]="isAddingMessage$ | async"
        >
          Send
        </app-button>
      </li>
    </ul>
  </div>
</ng-container>
